import React, { useState } from 'react';
import ArrowDown from '@uber/base-icons/arrow-down';
import ArrowUp from '@uber/base-icons/arrow-up';
import { styled } from 'baseui';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { SectionHeader, StyledHeading } from '../styled-component-overrides';
import type { ReviewAnnotationT } from '../types';
import { AttributeContainer } from './attribute-container';
type Props = {
  annotation: ReviewAnnotationT;
};
const SubSectionHeader = styled(SectionHeader, ({
  $theme
}) => ({
  marginBottom: $theme.sizing.scale100
}));
const AttributeHeading = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale100,
  alignItems: 'center'
}));
export const TaskClassification = ({
  annotation
}: Props) => {
  const [isAttributeExpanded, setIsAttributeExpanded] = useState<boolean>(false);
  return <>
      {annotation.attributes && annotation.attributes.length !== 0 && <>
          <SubSectionHeader>
            <AttributeHeading>
              <StyledHeading>Task Classification</StyledHeading>
            </AttributeHeading>
            <Button size={SIZE.mini} shape={SHAPE.square} kind={KIND.secondary} onClick={() => setIsAttributeExpanded(!isAttributeExpanded)} data-testid="toggle-attribute-expansion">
              {isAttributeExpanded ? <ArrowUp /> : <ArrowDown />}
            </Button>
          </SubSectionHeader>

          <AttributeContainer
      // @ts-expect-error todo(ts-migration) TS2322 Type 'ReviewAnnotationAttributesT | undefined' is not assignable to type 'ReviewAnnotationAttributesT'.
      attributes={annotation.attributes[0]} isAttributeExpanded={isAttributeExpanded} />
        </>}
    </>;
};